import React, { useContext, useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { useSelector } from 'react-redux';
import { selectUser } from '../../services/store/userSlice';
import moment from "moment";
import { InputTextarea } from "primereact/inputtextarea";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { trainingApi, timesheetApi } from "../../services";
import { settingService } from "../../services/extensions";
import { useFormik } from "formik";
import { skillService } from "../../services/profile";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { projectStatusOfResource } from '../../common/util/constants';

const CreateTrfForm = ({ reload, setNewTrf, setScreen, isEdit, editTrfForm, updateClickedRow, skillFormData }) => {
  const loggedInUser = useSelector(selectUser);
  const [trainingCategory, setTrainingCategory] = useState([]);
  const [addSkillDialog, setAddSkillDialog] = useState(false);
  const [newSkillTitle, setNewSkillTitle] = useState('');
  const [skillList, setSkillList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [currentProject, setCurrentProject] = useState([]);
  const [resourceProjectStatus, setResourceProjectStatus] = useState([]);
  const [skillLevel, setSkillLevel] = useState([]);
  const [selectedSkillLevel, setSelectedSkillLevel] = useState(null);
  const [rowClick, setRowClick] = useState(true);
  const [reqTrainingPurpose, setReqTrainingPurpose] = useState([]);
  const [outComeTrainingPurpose, setOutComeTrainingPurpose] = useState([]);
  const [nominatedEmployeeDetails, setNominatedEmployeeDetails] = useState(null);
  const [currentstatus, setCurrentstatus] = useState([]);
  const [skillLevelStatus, setSkillLevelStatus] = useState(false);
  const [reqTrainingStatus, setReqTrainingStatus] = useState(false);
  const [outComeStatus, setOutComeStatus] = useState(false);
  const [selectedEmpDetail, setSelectedEmpDetail] = useState({});
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [nominatedParticipant, setNominatedParticipant] = useState(null);
  const [currentSkillLevel, setCurrentSkillLevel] = useState(null);
  const [allProjects, setAllProjects] = useState([]);


  useEffect(() => {
    const mockSkillsLevel = [
      {
        id: 1,
        skills: <b>Current skill competency level</b>,
        beginnerNoKnowledge: false,
        beginnerBasicKnowledge: false,
        intermediateGoodKnowledge: false,
        intermediateStrongExperience: false,
        expert: false,
      },
      {
        id: 2,
        skills: <b>Expected skill competency level</b>,
        beginnerNoKnowledge: false,
        beginnerBasicKnowledge: false,
        intermediateGoodKnowledge: false,
        intermediateStrongExperience: false,
        expert: false,
      },
    ];
    if (isEdit) {
      const curr_lvl = fetchLevelName(editTrfForm?.currentLevel)
      const exp_lvl = fetchLevelName(editTrfForm?.expectedLevel)
      if (curr_lvl || exp_lvl) {
        setCurrentandExpectedSkillSet(curr_lvl, exp_lvl, mockSkillsLevel)
      }
      else setSkillLevel(mockSkillsLevel);
    }
    fetchAllProjects();
    setSkillLevel(mockSkillsLevel);
    fetchSkillsList();
    fetchEngagement();
    fetchCategories();
    fetchRequestedTraining();
    getManagerUserInfo({ pageNum: 0, pageSize: 400 });
  }, []);

  const fetchAllProjects = () => {
    settingService.getActiveProjects().then((resp) => {
      setAllProjects(resp.data.data);
    });
  };

  const setCurrentandExpectedSkillSet = (curr_lvl, exp_lvl, productslist) => {
    productslist[0][curr_lvl] = true;
    productslist[1][exp_lvl] = true;
    setCurrentSkillLevel(curr_lvl);
    setSkillLevel(productslist);
  }

  const fetchLevelName = (val) => {
    var current_level;
    switch (val) {
      case 1:
        current_level = "beginnerNoKnowledge";
        break;
      case 2:
        current_level = "beginnerBasicKnowledge";
        break;
      case 3:
        current_level = "intermediateGoodKnowledge";
        break;
      case 4:
        current_level = "intermediateStrongExperience";
        break;
      case 5:
        current_level = "expert";
        break;
      default:
        current_level = "";
    }
    return current_level;
  }

  const fetchSkillsList = () => {
    skillService.getSkills().then((resp) => {
      setSkillList(resp.data.data);
    });
  };

  const fetchEngagement = () => {
    trainingApi.getEngagementTypes().then((resp) => {
      setCurrentstatus(resp.data.data);
    });
  };

  // const fetchRequestedTraining = () => {
  //   let purposeReqTrainingData;
  //   let businessOutcomeTrainingData;
  //   trainingApi.getRequestedTraining().then((resp) => {
  //     purposeReqTrainingData = resp?.data?.data?.filter(item => item.type === 0);
  //     businessOutcomeTrainingData = resp?.data?.data?.filter(item => item.type === 1);
  //     if (isEdit) {
  //       const selectedReqIds = editTrfForm?.purposeOfRequestedTraining?.split(',').map(id => parseInt(id, 10));
  //       const updatedReqTrainingPurpose = purposeReqTrainingData?.map(item => ({
  //         ...item,
  //         isChecked: selectedReqIds.includes(item.id) ? true : item.isChecked
  //       }));
  //       purposeReqTrainingData = updatedReqTrainingPurpose;

  //       const selectedOutIds = editTrfForm?.businessoutcome.split(',').map(id => parseInt(id, 10));
  //       const updatedOutcomeTrainingPurpose = businessOutcomeTrainingData.map(item => ({
  //         ...item,
  //         isChecked: selectedOutIds.includes(item.id) ? true : item.isChecked
  //       }));
  //       businessOutcomeTrainingData = updatedOutcomeTrainingPurpose;
  //     } else {
  //       purposeReqTrainingData = resp.data.data.filter(item => item.type === 0);
  //       businessOutcomeTrainingData = resp.data.data.filter(item => item.type === 1);
  //     }
  //     setReqTrainingPurpose(purposeReqTrainingData);
  //     setOutComeTrainingPurpose(businessOutcomeTrainingData);
  //   });
  // };


  const fetchRequestedTraining = () => {
    let purposeReqTrainingData;
    let businessOutcomeTrainingData;
    trainingApi.getRequestedTraining().then((resp) => {
      purposeReqTrainingData = resp?.data?.data?.filter(item => item.type === 0);
      businessOutcomeTrainingData = resp?.data?.data?.filter(item => item.type === 1);
      if (isEdit) {
        const updatedReqTrainingPurpose = purposeReqTrainingData.map(item => {
          const match = editTrfForm?.purposeOfRequestedTraining.find(a => a.id === item.id);
          if (match) {
            item.isChecked = true;
          }
          return item;
        });
        purposeReqTrainingData = updatedReqTrainingPurpose;
        const updatedOutcomeTrainingPurpose = businessOutcomeTrainingData.map(item => {
          const match = editTrfForm?.businessoutcome.find(a => a.id === item.id);
          if (match) {
            item.isChecked = true;
          }
          return item;
        });
        businessOutcomeTrainingData = updatedOutcomeTrainingPurpose;
      } else {
        purposeReqTrainingData = resp.data.data.filter(item => item.type === 0);
        businessOutcomeTrainingData = resp.data.data.filter(item => item.type === 1);
      }
      setReqTrainingPurpose(purposeReqTrainingData);
      setOutComeTrainingPurpose(businessOutcomeTrainingData);
    });
  };

  const fetchCategories = () => {
    trainingApi.fetchTrainingCategoryList().then((resp) => {
      setTrainingCategory(resp.data.data);
    });
  };

  const getManagerUserInfo = (param = {}) => {
    timesheetApi.getUsersBySuperior(param).then((resp) => {
      try {
        if (resp?.data?.data.length > 0) {
          const data = resp?.data?.data;
          const transformedData = data.map((user) => {
            return {
              ...user,
              name: `${user.firstName} ${user.lastName}`.trim(),
            }
          });

          if (isEdit) {
            let selectedEmpData = transformedData.filter((item) => item.id === editTrfForm.userId);
            formik.setFieldValue("nominatedParticipant", selectedEmpData[0]);
            setSelectedEmpDetail(selectedEmpData[0]);
            const result = selectedEmpData[0].Allocations.map(item => ({ isBillable: item.isBillable, billableTitle: item.isBillable ? 'Billable' : 'Non-Billable', title: item.Project.title }));
            setCurrentProject(result);
            setResourceProjectStatus(result);
            if (selectedEmpData[0].Allocations?.length > 0) {
              const firstBillableItem = selectedEmpData[0].Allocations.find(item => item.isBillable === true);
              if (firstBillableItem) {
                const filteredBillableStatus = result.filter(item => item.isBillable === true);
                formik.setFieldValue("resourceCurrentProject", firstBillableItem?.Project?.title);
                formik.setFieldValue("resourceProjectStatus", filteredBillableStatus[0]?.billableTitle);
              } else {
                formik.setFieldValue("resourceCurrentProject", result[0]?.title);
                formik.setFieldValue("resourceProjectStatus", result[0]?.billableTitle);
              }
            } else {
              setCurrentProject([]);
            }
          }

          if (Object.keys(skillFormData).length > 0) {
            let selectedEmpData = transformedData.filter((item) => item.id === skillFormData.userId);
            formik.setFieldValue("nominatedParticipant", selectedEmpData[0]);
            setSelectedEmpDetail(selectedEmpData[0]);
            const result = selectedEmpData[0].Allocations.map(item => ({ isBillable: item.isBillable, billableTitle: item.isBillable ? 'Billable' : 'Non-Billable', title: item.Project.title }));
            setCurrentProject(result);
            setResourceProjectStatus(result);
            if (selectedEmpData[0].Allocations?.length > 0) {
              const firstBillableItem = selectedEmpData[0].Allocations.find(item => item.isBillable === true);
              if (firstBillableItem) {
                const filteredBillableStatus = result.filter(item => item.isBillable === true);
                formik.setFieldValue("resourceCurrentProject", firstBillableItem?.Project?.title);
                formik.setFieldValue("resourceProjectStatus", filteredBillableStatus[0]?.billableTitle);
              } else {
                formik.setFieldValue("resourceCurrentProject", result[0]?.title);
                formik.setFieldValue("resourceProjectStatus", result[0]?.billableTitle);
              }
            } else {
              setCurrentProject([]);
            }
          }
          setEmployeeList(transformedData);
        }
      } catch (error) {
        // Error handle
      }
    });
  };

  const handleAddNewSkill = async () => {
    const title = newSkillTitle.trim();
    if (!title) return;
    try {
      const res = await skillService.findOrCreateSkill(title);
      const skill = res.data?.data;
      if (!skillList.some(s => s.id === skill.id)) {
        setSkillList(prev => [...prev, skill]);
      }
      formik.setFieldValue('targetSkill', skill);
      setNewSkillTitle('');
      setAddSkillDialog(false);
      toast.success('Skill added successfully');
    } catch {
      toast.error('Failed to add skill');
    }
  };

  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const formik = useFormik({
    initialValues: {
      requesterName: loggedInUser?.firstName + " " + loggedInUser?.lastName,
      requesterEcn: loggedInUser?.ecn,
      requesterBu: "BU-" + loggedInUser?.businessUnitId,
      requisitionDate: new Date(),
      trainingType: isEdit ? editTrfForm?.trainingType : null,
      trainingCategory: isEdit ? editTrfForm?.categoryOfTraining : null,
      targetSkill: isEdit ? editTrfForm?.targetSkills : skillFormData?.targetSkills ? skillFormData?.targetSkills : null,
      // nominatedParticipant: null,
      // resourceCurrentProject: null,
      // resourceProjectStatus: null,
      resourceCurrentTech: isEdit ? editTrfForm?.currentTechnology : skillFormData ? skillFormData?.currentTechnology : "",
      requestedTrainingProject: isEdit ? editTrfForm?.requestedTrainingProject : null,
      trainingStartDate: isEdit ? new Date(editTrfForm?.startDateOfTraining) : "",
      trainingEndDate: isEdit ? new Date(editTrfForm?.endDateOfTraining) : "",
      improvmentAreaComment: isEdit ? editTrfForm?.improvementAreaTriggeringTrainingNeed : skillFormData ? skillFormData?.improvementAreaTriggeringTrainingNeed : "",
      moduleDetails: isEdit ? editTrfForm?.moduleSpecificDetails : skillFormData ? skillFormData?.moduleSpecificDetails : "",
      skillsetLevel: "",
      reqTrainingPurpose: []
    },
    validate: (data) => {
      // console.log(data, "Validation Data")
      let errors = {};
      const isValid = skillLevel.every(item =>
        Object.values(item).some(value => value === true)
      );
      if (!isValid) {
        setSkillLevelStatus(true);
      }
      let requestedTrainingList = reqTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
      let outComeTrainingList = outComeTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
      if (requestedTrainingList.length === 0) {
        setReqTrainingStatus(true);
      }
      if (outComeTrainingList.length === 0) {
        setOutComeStatus(true);
      }
      if (!data.trainingType) errors.trainingType = "Type is required";
      if (!data.trainingCategory) errors.trainingCategory = "Category is required";
      if (!data.targetSkill) errors.targetSkill = 'Target Skill is required.';
      // if (!data.nominatedParticipant) errors.nominatedParticipant = 'Participant Name is required.';
      // if (!data.resourceCurrentProject) errors.resourceCurrentProject = 'Project is required.';
      // if (!data.resourceProjectStatus) errors.resourceProjectStatus = 'Resource Status is required.';
      if (!data.resourceCurrentTech) errors.resourceCurrentTech = 'Current Tech. is required.';
      if (!data.trainingEndDate) errors.trainingEndDate = 'End Date is required.';
      if (!data.trainingStartDate) errors.trainingStartDate = 'End Date is required.';
      if (!data.improvmentAreaComment) errors.improvmentAreaComment = 'Triggering Area is required.';
      if (!data.moduleDetails) errors.moduleDetails = 'Details is required.';
      if (!data.requestedTrainingProject) errors.requestedTrainingProject = 'Project is required.';

      return errors;
    },
    onSubmit: (data) => {
      // console.log(data, "Final Data");
      let requestedTrainingList = reqTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
      let outComeTrainingList = outComeTrainingPurpose.filter(item => item.isChecked).map(item => item.id);
      let trfPayload = {
        // "userId": isEdit ? selectedEmpDetail.id : nominatedEmployeeDetails?.id,
        // "userId": isEdit ? selectedEmpDetail?.id : (skillFormData?.userId ? selectedEmpDetail?.id : nominatedEmployeeDetails?.id),
        "nameOfRequester": data?.requesterName,
        "ecnOfRequester": data?.requesterEcn,
        "businessUnit": data?.requesterBu,
        "trainingRequisitionDate": moment(data?.requisitionDate).format("YYYY-MM-DD"),
        "trainingType": data?.trainingType,
        "categoryOfTraining": data?.trainingCategory,
        "targetSkill": data?.targetSkill?.id,
        "targetSkillName": data?.targetSkill?.title,
        "requestedTrainingProject": data?.requestedTrainingProject,
        // "nameOfNominatedParticipant": data?.nominatedParticipant?.name,
        // "currentStatusOfNominatedResource": data?.resourceProjectStatus === "Billable" ? 1 : 2,
        // "projectName": data?.resourceCurrentProject,
        "currentTechnology": data?.resourceCurrentTech,
        "startDateOfTraining": moment(data?.trainingStartDate).format("YYYY-MM-DD"),
        "endDateOfTraining": moment(data?.trainingEndDate).format("YYYY-MM-DD"),
        "purposeStartDateOfTraining": moment(data?.trainingStartDate).format("YYYY-MM-DD"),
        "purposeEndDateOfTraining": moment(data?.trainingEndDate).format("YYYY-MM-DD"),
        "improvementAreaTriggeringTrainingNeed": data?.improvmentAreaComment,
        "moduleSpecificDetails": data?.moduleDetails,
        "currentLevel": fetchValue(0),
        "expectedLevel": fetchValue(1),
        "currentLevelValue": fetchLevelValue(0),
        "expectedLevelValue": fetchLevelValue(1),
        "purposeOfRequestedTraining": requestedTrainingList,
        "purposeOfRequestedTrainingDetails": reqTrainingPurpose.filter(item => item.isChecked).map(item => item.title).join(','),
        "businessoutcome": outComeTrainingList,
        "businessOutcomeDetails": outComeTrainingPurpose.filter(item => item.isChecked).map(item => item.title).join(','),
        "nominatedParticipants": nominatedParticipant
      }
      if (isEdit) {
        trfPayload = {
          ...trfPayload,
          id: editTrfForm?.id
        }
        UpdateUserTrfFormm(trfPayload);
      } else {
        if (!skillLevelStatus && !reqTrainingStatus && !outComeStatus) {
          CreateUserTrfFormm(trfPayload);
        }
      }
      updateClickedRow({});
    },
  });

  const CreateUserTrfFormm = (params) => {
    try {
      // trainingApi.createTRFform(params).then(
      trainingApi.createMultiTRFform(params).then(
        (resp) => {
          toast.success(resp.data.message);
          if (resp?.data?.data) {
            setTimeout(() => {
              setNewTrf(false);
              reload();
              setScreen('listing');
            }, 1000);
          }
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to update");
    }
  }
  const UpdateUserTrfFormm = (params) => {
    try {
      trainingApi.updateTRFform(params).then(
        (resp) => {
          toast.success(resp?.data?.message);
          setTimeout(() => {
            setNewTrf(false);
            reload();
            setScreen('listing');
          }, 1000);
        },
        (err) => {
          toast.error(err.response.data.error);
        }
      );
    } catch (error) {
      toast.error("Unable to update");
    }
  }

  const fetchLevelValue = (index) => {
    const getKeyByValue = (obj, value) => {
      return Object.keys(obj).find(key => obj[key] === value);
    };
    const keyWithTrueValue = getKeyByValue(skillLevel[index], true);
    return fetchLevelValName(keyWithTrueValue);
  };

  const fetchValue = (index) => {
    const getKeyByValue = (obj, value) => {
      return Object.keys(obj).find(key => obj[key] === value);
    };
    const keyWithTrueValue = getKeyByValue(skillLevel[index], true);
    return fetchLevelNumber(keyWithTrueValue);
  };

  const fetchLevelNumber = (levelName) => {
    const levelMapping = {
      "beginnerNoKnowledge": 1,
      "beginnerBasicKnowledge": 2,
      "intermediateGoodKnowledge": 3,
      "intermediateStrongExperience": 4,
      "expert": 5
    };
    return levelMapping[levelName] || null;
  };

  const fetchLevelValName = (levelName) => {
    const levelMapping = {
      "beginnerNoKnowledge": 'Beginner Level',
      "beginnerBasicKnowledge": 'Basic Level',
      "intermediateGoodKnowledge": 'Intermediate Level',
      "intermediateStrongExperience": 'Strong Level',
      "expert": 'Expert Level'
    };
    return levelMapping[levelName] || null;
  };

  // const handleDateChange = (date) => {
  //   formik.setFieldValue("requisitionDate", date);
  //   formik.setFieldValue("trainingEndDate", "");
  // };

  const handleTrainingStartDateChange = (date) => {
    formik.setFieldValue("trainingStartDate", date);
    formik.setFieldValue("trainingEndDate", "");
  }
  const handleTrainingEndDateChange = (date) => {
    formik.setFieldValue("trainingEndDate", date);
  }

  const nomiatedEmpInfo = (e) => {
    // console.log(e.target.value, "<<<>>>>", e.value);
    setSelectedParticipant(e.value);
    const nominatedParticipants = e.value.map(item => {
      if (!item.Allocations?.length) return null;
      // find first billable project
      const firstBillable = item.Allocations.find(a => a.isBillable === true);
      // pick either first billable or fallback to first allocation
      const chosen = firstBillable || item.Allocations[0];
      return {
        userId: item.id,
        nameOfNominatedParticipant: item.name,
        currentStatusOfNominatedResource: chosen.isBillable ? 1 : 0,
        projectName: chosen.Project?.title || ''
      };
    }).filter(Boolean);
    // console.log(nominatedParticipants, "nominatedParticipants");
    setNominatedParticipant(nominatedParticipants);

    // setNominatedEmployeeDetails(e.target.value);
    // const result = e.target.value.Allocations.map(item => ({ isBillable: item.isBillable, billableTitle: item.isBillable ? 'Billable' : 'Non-Billable', title: item.Project.title }));
    // formik.setFieldValue("nominatedParticipant", e.target.value);
    // setCurrentProject(result);
    // // setResourceProjectStatus(result);
    // if (e.target.value.Allocations?.length > 0) {
    //   const firstBillableItem = e.target.value.Allocations.find(item => item.isBillable === true);
    //   if (firstBillableItem) {
    //     const filteredBillableStatus = result.filter(item => item.isBillable === true);
    //     formik.setFieldValue("resourceCurrentProject", firstBillableItem?.Project?.title);
    //     formik.setFieldValue("resourceProjectStatus", filteredBillableStatus[0]?.billableTitle);
    //   } else {
    //     formik.setFieldValue("resourceCurrentProject", result[0]?.title);
    //     formik.setFieldValue("resourceProjectStatus", result[0]?.billableTitle);
    //   }
    // } else {
    //   setCurrentProject([]);
    // }
  }

  /* Skill Level Template Start */
  const radioTemplate = (skillLevelRadio) => (rowData) => {
    const isCurrentRow = rowData.id === 1;
    const isExpectedRow = rowData.id === 2;
    const skillLevels = ['beginnerNoKnowledge', 'beginnerBasicKnowledge', 'intermediateGoodKnowledge', 'intermediateStrongExperience', 'expert'];
    const currentLevelIndex = currentSkillLevel ? skillLevels.indexOf(currentSkillLevel) : -1;
    const currentRadioIndex = skillLevels.indexOf(skillLevelRadio);

    let isDisabled = false;

    if (isCurrentRow && skillLevelRadio === 'expert') {
      isDisabled = true;
    }

    if (isExpectedRow && currentSkillLevel && currentRadioIndex <= currentLevelIndex) {
      isDisabled = true;
    }

    return (
      <RadioButton
        inputId={`${rowData.id}-${skillLevelRadio}`}
        checked={rowData[skillLevelRadio]}
        onChange={() => handleRadioSelection(rowData.id, skillLevelRadio)}
        disabled={isDisabled}
      />
    );
  };

  const handleRadioSelection = (productId, skillLevelRadio) => {
    const updatedProducts = skillLevel.map((product) => {
      if (product.id === productId) {
        return {
          ...product,
          beginnerNoKnowledge: skillLevelRadio === "beginnerNoKnowledge",
          beginnerBasicKnowledge: skillLevelRadio === "beginnerBasicKnowledge",
          intermediateGoodKnowledge: skillLevelRadio === "intermediateGoodKnowledge",
          intermediateStrongExperience:
            skillLevelRadio === "intermediateStrongExperience",
          expert: skillLevelRadio === "expert",
        };
      }
      return product;
    });

    if (productId === 1) {
      setCurrentSkillLevel(skillLevelRadio);
      const expectedProduct = updatedProducts.find(p => p.id === 2);
      if (expectedProduct) {
        const skillLevels = ['beginnerNoKnowledge', 'beginnerBasicKnowledge', 'intermediateGoodKnowledge', 'intermediateStrongExperience', 'expert'];
        const currentIndex = skillLevels.indexOf(skillLevelRadio);
        const expectedKeys = Object.keys(expectedProduct).filter(key => expectedProduct[key] === true && key !== 'id' && key !== 'skills');

        if (expectedKeys.length > 0) {
          const expectedIndex = skillLevels.indexOf(expectedKeys[0]);
          if (expectedIndex <= currentIndex) {
            updatedProducts[1] = {
              ...updatedProducts[1],
              beginnerNoKnowledge: false,
              beginnerBasicKnowledge: false,
              intermediateGoodKnowledge: false,
              intermediateStrongExperience: false,
              expert: false,
            };
          }
        }
      }
    }

    const isValid = updatedProducts.every(item =>
      Object.values(item).some(value => value === true)
    );
    if (isValid) {
      setSkillLevelStatus(false);
    }
    setSkillLevel(updatedProducts);
  };
  /* Skill Level Template Start */

  // const handleCheckboxChangeforPurpose = (e, item) => {
  //   const updatedData = reqTrainingPurpose.map(i =>
  //     i.id === item.id ? { ...i, isChecked: e.checked } : i
  //   );
  //   setReqTrainingStatus(false);
  //   setReqTrainingPurpose(updatedData);
  // };

  const handleCheckboxChangeforPurpose = (e, item) => {
    const isStrategicEmployeeAspiration = item.title === "Strategic - Employee Aspiration";
    const hasStrategicSelected = reqTrainingPurpose.some(i => i.title === "Strategic - Employee Aspiration" && i.isChecked);

    if (isStrategicEmployeeAspiration) {
      // When Strategic - Employee Aspiration is selected, deselect all others
      const updatedData = reqTrainingPurpose.map(i =>
        i.title === "Strategic - Employee Aspiration" ? { ...i, isChecked: e.checked } : { ...i, isChecked: false }
      );
      const hasTrue = updatedData.some(item => item.isChecked === true);
      setReqTrainingStatus(!hasTrue);
      setReqTrainingPurpose(updatedData);
    } else if (hasStrategicSelected) {
      // Allow multiple selections when Strategic - Employee Aspiration is already selected
      const updatedData = reqTrainingPurpose.map(i =>
        i.id === item.id ? { ...i, isChecked: e.checked } : i
      );
      const hasTrue = updatedData.some(item => item.isChecked === true);
      setReqTrainingStatus(!hasTrue);
      setReqTrainingPurpose(updatedData);
    } else {
      // Single selection for other options
      const updatedData = reqTrainingPurpose.map(i =>
        i.id === item.id ? { ...i, isChecked: true } : { ...i, isChecked: false }
      );
      setReqTrainingStatus(false);
      setReqTrainingPurpose(updatedData);
    }
  };

  const handleCheckboxChangeforBussiness = (e, item) => {
    // const updatedData = outComeTrainingPurpose.map(i =>
    //   i.id === item.id ? { ...i, isChecked: e.checked } : i
    // );
    const updatedData = outComeTrainingPurpose.map(i =>
      i.id === item.id ? { ...i, isChecked: true } : { ...i, isChecked: false }
    );
    setOutComeStatus(false);
    setOutComeTrainingPurpose(updatedData);
  };

  const trainingType = [
    { name: "Self-Paced", value: "Self-Paced" },
    { name: "Instructor-Led", value: "Instructor-Led" },
  ];

  return (
    <div className="card full_dialog full_dialog2">
      <form onSubmit={formik.handleSubmit} autoComplete='off'>
        {/* <div className="flex flex-wrap p-field font-bold block">
          <div className="col-4">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Name Of Requester (RO)</label>
            <InputText name="requesterName" placeholder="Enter Name" className="w-full" value={formik.values.requesterName} disabled />
          </div>
          <div className="col-4">
            <label htmlFor="number" className="font-bold block mb-2 training-heading mt-2">ECN Of Requester</label>
            <InputText name="requesterEcn" placeholder="Enter ECN" className="w-full" value={formik.values.requesterEcn} disabled />
          </div>
          <div className="col-4">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Business Unit / Function</label>
            <InputText name="requesterBu" placeholder="BU" className="w-full" value={formik.values.requesterBu} disabled />
          </div>
        </div> */}

        <div className="flex flex-wrap p-field font-bold block">
          <div className="col-4">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Training Type</label>
            <Dropdown name="trainingType" value={formik.values.trainingType} onChange={(e) => formik.handleChange(e)} options={trainingType} optionLabel="name" optionValue="value" placeholder="Select Type" className="w-full" />
            {getFormErrorMessage('trainingType')}
          </div>
          <div className="col-4">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Category Of Training</label>
            <Dropdown name="trainingCategory" value={formik.values.trainingCategory} onChange={(e) => formik.handleChange(e)} options={trainingCategory} optionLabel="title" optionValue="id" placeholder="Select a Category" className="w-full" />
            {getFormErrorMessage('trainingCategory')}
          </div>
          <div className="col-4">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Target Skill</label>
            <div className="flex align-items-center gap-2">
              <Dropdown
                name="targetSkill"
                value={formik.values.targetSkill}
                onChange={(e) => formik.setFieldValue('targetSkill', e.value)}
                options={skillList}
                optionLabel="title"
                placeholder="Select Target Skill"
                // className="w-full"
                style={{ width: '220px' }}
                filter
              />
              <Button
                type="button"
                icon="pi pi-plus"
                label="Add New Skill"
                className="p-button-text p-button-sm white-space-nowrap"
                onClick={() => { setNewSkillTitle(''); setAddSkillDialog(true); }}
              />
            </div>
            {getFormErrorMessage('targetSkill')}
          </div>
        </div>
        <Dialog
          header="Add New Skill"
          visible={addSkillDialog}
          style={{ width: '350px' }}
          onHide={() => setAddSkillDialog(false)}
          footer={
            <div>
              <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => setAddSkillDialog(false)} />
              <Button label="Save" icon="pi pi-check" onClick={handleAddNewSkill} disabled={!newSkillTitle.trim()} />
            </div>
          }
        >
          <div className="p-fluid">
            <label className="font-bold block mb-2">Skill Name</label>
            <InputText
              value={newSkillTitle}
              onChange={(e) => setNewSkillTitle(e.target.value)}
              placeholder="Enter skill name"
              onKeyDown={(e) => e.key === 'Enter' && handleAddNewSkill()}
              autoFocus
            />
          </div>
        </Dialog>
        <div className="flex flex-wrap p-field font-bold block">
          <div className="col-4">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Name Of Nominated Participant</label>
            {/* <Dropdown value={formik.values.nominatedParticipant} onChange={(e) => nomiatedEmpInfo(e)} options={employeeList} name="nominatedParticipant" filter optionLabel="name" placeholder="Select Employees" className="w-full" disabled={isEdit ? true : false} /> */}

            <MultiSelect filter value={selectedParticipant} options={employeeList} onChange={(e) => nomiatedEmpInfo(e)} optionLabel="name" placeholder="Select Employees" maxSelectedLabels={1} showClear={false} className="w-full" disabled={isEdit ? true : false} />

            {/* <MultiSelect filter value={selectedProject} options={allocatedProjectData} onChange={(e) => changeUserByProject(e)} optionLabel="title" placeholder="Select Project" maxSelectedLabels={1} showClear={false} style={{ width: "150px" }} className={classNames({ "p-invalid": errorLog && !selectedProject }, "mt-2")} /> */}

            {getFormErrorMessage('nominatedParticipant')}
          </div>
          {/* <div className="col-4">
            <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Project Details</label>
            <Dropdown name="resourceCurrentProject" value={formik.values.resourceCurrentProject} onChange={(e) => formik.handleChange(e)} options={currentProject} optionLabel="title" optionValue="title" placeholder="Select Project" className="w-full" disabled={isEdit ? true : false} />
            {getFormErrorMessage('resourceCurrentProject')}
          </div> */}
          {/* <div className="col-4">
            <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Current Status Of Nominated Resource</label>
            <Dropdown name="resourceProjectStatus" value={formik.values.resourceProjectStatus} onChange={(e) => formik.handleChange(e)} options={projectStatusOfResource} optionValue="title" optionLabel="title" placeholder="Select Status" className="w-full" disabled={isEdit ? true : false} />
            {getFormErrorMessage('resourceProjectStatus')}
          </div> */}

          <div className="col-4">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Current Technology</label>
            <InputText name="resourceCurrentTech" value={formik.values.resourceCurrentTech} onChange={(e) => formik.handleChange(e)} placeholder="Enter Current Technology" className="w-full" style={{ background: "#fff" }} />
            {getFormErrorMessage('resourceCurrentTech')}
          </div>
          <div className="col-4">
            <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">Training Requisition Date</label>
            <Calendar name="requisitionDate" value={formik.values.requisitionDate} minDate={new Date()} placeholder="Select Date" showIcon className="w-full requisition-date" disabled={true} />
          </div>
          <div className="col-4">
            <label htmlFor="text" className="font-bold block mb-2 mt-2 training-heading">Start Date for Training</label>
            <Calendar name="trainingStartDate" value={formik.values.trainingStartDate} onChange={(e) => handleTrainingStartDateChange(e.target.value)} minDate={new Date()} placeholder="Select Date" showIcon className="w-full requisition-date" />
            {getFormErrorMessage('trainingStartDate')}
          </div>
          <div className="col-4">
            <label htmlFor="text" className="font-bold block mb-2 mt-2 training-heading">End Date for Training</label>
            <Calendar name="trainingEndDate" value={formik.values.trainingEndDate} onChange={(e) => handleTrainingEndDateChange(e.target.value)} minDate={formik.values.trainingStartDate ? new Date(new Date(formik.values.trainingStartDate).getTime() + 86400000) : new Date()} placeholder="Select Date" showIcon className="w-full requisition-date" />
            {getFormErrorMessage('trainingEndDate')}
          </div>
        </div>

        <div className="flex flex-wrap p-field font-bold block">
          <div className="col-6">
            <label htmlFor="improvementArea" className="font-bold block mb-2 training-heading mt-2">Improvement Area Triggering Training Need</label>
            <InputTextarea name="improvmentAreaComment" placeholder="Mention specific improvement areas within the required technology..." rows={3} className="w-full" style={{ background: "#fff" }} value={formik.values.improvmentAreaComment} onChange={(e) => formik.handleChange(e)} />
            {getFormErrorMessage('improvmentAreaComment')}
          </div>
          <div className="col-6">
            <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Module-Specific Details</label>
            <InputTextarea name="moduleDetails" placeholder="Enter Module Details" rows={3} className="w-full" style={{ background: "#fff" }} value={formik.values.moduleDetails} onChange={(e) => formik.handleChange(e)} />
            {getFormErrorMessage('moduleDetails')}
          </div>
        </div>

        <div className="flex flex-wrap p-field font-bold block">
          <div className="col-12">
            <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Current & Expected Level Of Skillset</label>
            <DataTable value={skillLevel} showGridlines selectionMode={rowClick ? null : "radiobutton"} selection={selectedSkillLevel} onSelectionChange={(e) => setSelectedSkillLevel(e.value)} dataKey="id" tableStyle={{ minWidth: "50rem" }}>
              <Column field="skills" header="Skills" style={{ width: "200px" }}></Column>
              <Column body={radioTemplate("beginnerNoKnowledge")} header="Beginner with no knowledge" style={{ width: "200px" }}></Column>
              <Column body={radioTemplate("beginnerBasicKnowledge")} header="Beginner with basic knowledge" style={{ width: "200px" }}></Column>
              <Column body={radioTemplate("intermediateGoodKnowledge")} header="Intermediate with good knowledge but no hands-on experience" style={{ width: "200px" }}></Column>
              <Column body={radioTemplate("intermediateStrongExperience")} header="Intermediate with strong hands-on experience" style={{ width: "200px" }}></Column>
              <Column body={radioTemplate("expert")} header="Expert"></Column>
            </DataTable>
            {skillLevelStatus && (<span style={{ color: 'red' }}>Select Current and Expected Skill Level!</span>)}
          </div>
        </div>

        <div className="flex flex-wrap p-field font-bold block">
          <div className="col-4">
            <label htmlFor="skillset" className="font-bold block mb-2 training-heading mt-2">Requested Training for Project</label>
            <Dropdown name="requestedTrainingProject" value={formik.values.requestedTrainingProject} onChange={(e) => formik.handleChange(e)} options={allProjects} optionLabel="title" optionValue="id" placeholder="Select Project" className="w-full" filter />
            {getFormErrorMessage('requestedTrainingProject')}
          </div>
        </div>

        <div className="flex flex-wrap p-field font-bold block">
          <div className="col-12">
            <label htmlFor="trainingPurpose" className="font-bold block mb-2 mt-2 training-heading table-header">Purpose of Requested Training</label>
            <div className="card">
              <div className="grid">
                {reqTrainingPurpose.map((category) => {
                  return (
                    <div key={category.code} className="flex align-items-center col-6">
                      <Checkbox inputId={category.code} name="reqTrainingPurpose" value={category}
                        checked={category.isChecked === true} onChange={(e) => handleCheckboxChangeforPurpose(e, category)} />
                      <label htmlFor={category.code} className="ml-2"> {category.title} </label>
                    </div>
                  );
                })}
              </div>
              {reqTrainingStatus && (<span style={{ color: 'red' }}>Select At Least One Purpose of Requested Training!</span>)}
            </div>
          </div>
        </div>

        <div className="flex flex-wrap p-field font-bold block">
          <div className="col-12">
            <label
              htmlFor="trainingPurpose"
              className="font-bold block mb-2 mt-2 training-heading table-header"
            >
              Which of business outcome (s) mentioned below going to be
              directly/indirectly impacted as an effectiveness of requested
              training ?
            </label>
            <div className="card">
              <div className="grid">
                {outComeTrainingPurpose.map((category) => {
                  return (
                    <div key={category.code} className="col-6">
                      <Checkbox
                        inputId={category.code}
                        name="outComeTrainingPurpose"
                        value={category}
                        checked={category.isChecked === true}
                        onChange={(e) => handleCheckboxChangeforBussiness(e, category)}
                      />
                      <label htmlFor={category.code} className="ml-2">
                        {category.title}
                      </label>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {outComeStatus && (<span style={{ color: 'red' }}>Select At Least One Business Outcome (s)!</span>)}
        </div>

        <div className="flex flex-wrap p-field font-bold block mt-4">
          <div className="col-12 flex">
            {/* <Button type="submit" label="Submit" /> */}
            {
              isEdit ? <Button type="submit" label="Update" /> :
                <Button type="submit" label="Submit" />
            }
            {/* {!parent && <Button label="Back" className="ml-1" severity="secondary" onClick={() => navigate("/training")} />} */}
          </div>
        </div>
      </form>




    </div>
  )
}

export default CreateTrfForm;
